export default "__VITE_ASSET__CjpiJTxY__"